<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav *ngIf="!readonly" class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" title="Volver" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinner" [disabled]="formInvalid" type="submit" title="Guardar" class="btn btn-outline-success"><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" type="button" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>

    <nav *ngIf="readonly && !dialogMode" class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" title="Volver" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid" [ngClass]="{ 'container-no-overflow': dialogMode }">
        <h4>{{ title }} Almacén</h4>

        <div class="card card-accent-success animated fadeIn">
            <a class="card-header-a" (click)="isCollapsed = !isCollapsed"
               [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
                <div class="card-header-buscador">
                    <i class="fa fa-filter"></i> Datos básicos
                    <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                    <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                </div>
            </a>
            <div class="card-body">

                <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">

                    <div class="row">

                        <div class="form-group col-xl-2 col-md-4">
                            <label class="col-form-label required-field" for="inpRegistroSanitario">Registro sanitario</label>
                            <input formControlName="RegistroSanitario" name="RegistroSanitario" maxlength="15" title="" [readonly]="readonly" class="form-control" id="inpRegistroSanitario" type="text" value="" [ngClass]="displayFieldCss('RegistroSanitario')">
                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('RegistroSanitario','required')">
                                El Registro Sanitario es obligatorio
                            </div>
                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('RegistroSanitario','registroSanitario_duplicated')">
                                El Registro Sanitario ya existe
                            </div>
                        </div>

                        <div class="form-group col-xl-2 col-md-4">
                            <label class="col-form-label" for="inpRazonSocial">Razón social</label>
                            <input formControlName="RazonSocial" name="RazonSocial" maxlength="200" title="" [readonly]="readonly" class="form-control" id="inpRazonSocial" type="text" value="">
                        </div>

                        <div class="form-group col-xl-2 col-md-4">
                            <label class="col-form-label" for="inpDireccion">Dirección</label>
                            <input formControlName="Direccion" name="Direccion" maxlength="200" title="" [readonly]="readonly" class="form-control" id="inpDireccion" type="text" value="">
                        </div>

                        <div class="form-group col-xl-2 col-md-4">
                            <label class="col-form-label" for="inpProvincia">Provincia</label>

                            <ng-select loadingText="Cargando..."
                                       [items]="listProvincias"
                                       placeholder="-- Seleccione una provincia --"
                                       [readonly]="!listProvincias || listProvincias.length === 0 || readonly"
                                       [loading]="!listProvincias || listProvincias.length === 0"
                                       bindLabel="Descripcion"
                                       bindValue="Id"
                                       formControlName="IdProvincia"
                                       notFoundText="Provincia no encontrada"
                                       (change)="onSelectProvincia()"
                                       clearAllText="Eliminar selección">
                            </ng-select>
                        </div>

                        <div class="form-group col-xl-2 col-md-4">
                            <label class="col-form-label" for="inpMunicipio">Municipio</label>

                            <ng-select loadingText="Cargando..."
                                       [items]="listMunicipios"
                                       placeholder="-- Seleccione un municipio --"
                                       [readonly]="!listMunicipios || listMunicipios.length === 0 || readonly"
                                       [loading]="(!listMunicipios || listMunicipios.length === 0) && (form.value.IdProvincia > 0)"
                                       bindLabel="Descripcion"
                                       bindValue="Id"
                                       formControlName="IdMunicipio"
                                       notFoundText="Municipio no encontrado"
                                       clearAllText="Eliminar selección">
                            </ng-select>
                        </div>

                        <div class="form-group col-xl-2 col-md-4">
                            <label class="col-form-label required-field" for="inpCambio">Motivo del cambio</label>
                            <ng-select loadingText="Cargando..."
                                       [items]="listCambios"
                                       placeholder="-- Seleccione un motivo --"
                                       [readonly]="!listCambios || listCambios.length === 0 || readonly"
                                       [loading]="!listCambios || listCambios.length === 0"
                                       bindLabel="Descripcion"
                                       bindValue="Id"
                                       formControlName="IdCambio"
                                       notFoundText="Motivo no encontrado"
                                       clearAllText="Eliminar selección"
                                       [ngClass]="displayFieldCssNgSelect('IdCambio')">
                            </ng-select>
                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdCambio','required')">
                                El Motivo del Cambio es obligatorio
                            </div>
                        </div>

                        <div class="form-group col-xl-2 col-md-4">
                            <label class="col-form-label" for="inpActivo">Activo</label>
                            <p-toggleButton class="form-control-togglebutton"
                                            formControlName="Activo"
                                            name="Activo"
                                            [disabled]="readonly"
                                            onLabel="Sí"
                                            offLabel="NO"
                                            onIcon="pi pi-check"
                                            offIcon="pi pi-times">
                            </p-toggleButton>
                        </div>

                        <div *ngIf="codigoConfeccion?.Desautorizado" class="form-group col-xl-2 col-md-4">
                            <label class="col-form-label" for="inpDesautorizado">Almacén Desautorizado</label>
                            <p-toggleButton class="form-control-togglebutton"
                                            formControlName="Desautorizado"
                                            [disabled]="readonly"
                                            name="Desautorizadao"
                                            onLabel="Sí"
                                            offLabel="NO"
                                            onIcon="pi pi-check"
                                            offIcon="pi pi-times">
                            </p-toggleButton>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="codigoConfeccion?.Desautorizado" class="card card-accent-success animated fadeIn">
            <a class="card-header-a" (click)="isCollapsedDesautorizados = !isCollapsedDesautorizados"
               [attr.aria-expanded]="!isCollapsedDesautorizados" aria-controls="collapseDesautorizados">
                <div class="card-header-buscador">
                    <i class="fa fa-filter"></i> Desautorizado en las siguientes campañas
                    <i *ngIf="isCollapsedDesautorizados" class="fa fa-caret-down float-right"></i>
                    <i *ngIf="!isCollapsedDesautorizados" class="fa fa-caret-up float-right"></i>
                </div>
            </a>
            <div class="card-body">

                <div class="collapse group-filtros" id="collapseDesautorizados" [ngbCollapse]="isCollapsedDesautorizados">

                    <div class="row">
                        <div *ngFor="let campania of codigoConfeccion?.CampaniasDesautorizado" class="nota-info">
                            <label class="col-form-label">{{ campania?.Descripcion }} el {{ campania.Fecha | date:'dd/MM/yyyy HH:mm' }}</label>
                        </div>
                    </div>

                </div>
            </div>
        </div>        
    </div>
</form>
